// Imports for external libraries go here.
import React, { FC } from 'react';
import { RichText } from '@marriott/mi-ui-library';
import clsx from 'clsx';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { constants } from '../../../../modules/utils/constants/constants';
import { OtpTimer } from '../../../../molecules/OtpTimer';
import { CreateAccountOtpTimerProps } from './CreateAccountOtpTimer.types';
import { StyledCreateAccountOtpTimer } from './CreateAccountOtpTimer.styles';

// Use named rather than default exports.
export const CreateAccountOtpTimer: FC<CreateAccountOtpTimerProps> = props => {
  return (
    <StyledCreateAccountOtpTimer data-testid="account-CreateAccountOtpTimer">
      {props?.showSendCode && (
        <div className={clsx(' t-font-xs d-flex mt-1', props?.disableField ? 'is-disabled' : '')}>
          {props?.enableTimer === 'true' && props?.otpTimer && props?.selectedOption !== constants.EMAIL ? (
            <OtpTimer
              handleOtp={props?.handleOtp}
              onTimerActiveChange={props?.handleTimerActiveChange}
              isOtpSent={props?.isOtpSent}
              timer={props?.otpTimer}
              timerRunningLabel={props?.timerRunningLabel}
              resendNewCodeLabel={props?.resendNewCodeLabel}
              otpValidationError={props?.otpValidationError}
              incorrectCodeRunningLabel={props?.incorrectCodeRunningLabel}
              verificationCodeInlineMessage={props?.verificationCodeInlineMessage}
              didNotGetACodeLabel={props?.didNotGetACodeLabel}
              resetTimer={props?.resetTimer}
            />
          ) : (
            <>
              <RichText
                text={
                  props?.incorrectVerificationCode || props?.expiredTransactionCode || props?.otpValidationError
                    ? props?.verificationCodeInlineMessage
                    : props?.didNotGetACodeLabel
                }
                componentId="verification-code"
                customClass={clsx(props?.otpValidationError ? 'error-label' : '')}
              />
              <div
                onClick={props?.handleOtp}
                className={clsx(
                  props?.otpValidationError ? 'error-label' : '',
                  'ml-1 pointer-cursor help-text-decoration mr-3 resend-code'
                )}
                data-testid="verify_code_eaa"
              >
                <RichText text={props?.resendNewCodeLabel} componentId="resend-new-code" />
              </div>
            </>
          )}
        </div>
      )}
    </StyledCreateAccountOtpTimer>
  );
};
